import React, { lazy, Suspense } from 'react';
import cn from 'classnames';
import Image from 'components/UI/Image';
import FullscreenButton from 'components/UI/FullscreenButton';
import { useStateModal } from 'utils/hooks';

import * as styles from './image.module.scss';

const ImageModal = lazy(() => import('components/Modals/ImageModal'));

export function Component({ content, className, lazy }) {
  const { caption, img } = content;
  const { modalState, showModal, hideModal } = useStateModal();
  const FigureTag = caption ? 'figure' : 'div';

  return (
    <div className={cn(className, styles.wrapper)}>
      <FigureTag className={styles.figure}>
        <div className={styles.pictureWrapper}>
          <Image
            lazy={lazy}
            src={img}
            className={styles.picture}
            alt={img?.alt ?? caption ?? 'Visual concept'}
          />
          <FullscreenButton className={styles.iconWrapper} onClick={showModal} />
        </div>
        {caption && <figcaption className={styles.figcaption}>{caption}</figcaption>}
      </FigureTag>
      <Suspense fallback={null}>
        <ImageModal isOpen={modalState.isOpen} closeModalCallback={hideModal} img={img} />
      </Suspense>
    </div>
  );
}
